import defaultValues from './defaultValues'

const styles = JSON.parse(defaultValues);

styles.Text.enabled = true;
styles.Text.props.fontSize.enabled = true;

export default styles;